(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-gv-restock]').forEach((panel) => {
      if (panel.dataset.ready === 'true') return;
      panel.dataset.ready = 'true';

      let variants = [];
      try {
        variants = JSON.parse(panel.querySelector('[data-gv-restock-variants]')?.textContent || '[]');
      } catch (_) {}

      const scope = panel.closest('.buy-buttons-block')?.parentElement || document;
      const variantInput = scope.querySelector('product-form-component input[name="id"]');
      const message = panel.querySelector('[data-gv-restock-message]');
      const productTitle = panel.dataset.productTitle || '';
      const productUrl = panel.dataset.productUrl || location.href.split('?')[0];

      const update = () => {
        const urlId = new URL(location.href).searchParams.get('variant');
        const id = String(variantInput?.value || urlId || '');
        const variant = variants.find((item) => String(item.id) === id) || variants[0];
        if (!variant) return;
        panel.hidden = variant.available;
        if (message) {
          message.value = `Verfügbarkeitsanfrage: ${productTitle} — ${variant.title} (${productUrl}?variant=${variant.id})`;
        }
      };

      update();
      variantInput?.addEventListener('change', update);
      if (variantInput) new MutationObserver(update).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      scope.addEventListener('change', () => requestAnimationFrame(update));
      window.addEventListener('popstate', update);
    });
  };

  setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
})();
